//External
import React from "react";
import { Form } from "react-bootstrap";
import { capitalizeFirstWord, strToLowerCase } from "utils";

/*******************
  @Purpose : used for category
  @Parameter : { formik, id, name, placeholder, type = 'text', optional = false, ...props }
  @Author : INIC
  *******************/
function FormInput({
  formik,
  id,
  name,
  placeholder,
  type = "text",
  optional = false,
  withoutParanetclass,
  disabled,
  ...props
}) {
  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <div className="input-field form-group">
      <div className="floating-form">
        <Form.Group
          controlid="billingZipCode"
          className={`floating-form-group ${
            formik?.touched[name] && formik?.errors[name] && "error"
          } ${disabled ? "disable" : ""}`}
        >
          <Form.Control
            id={id}
            type={type}
            className="floating-input"
            placeholder={capitalizeFirstWord(placeholder)}
            name={name}
            onChange={async (e) => {
              let val = e.target.value.replace(/\s\s+/g, " ").trimStart();
              if (name === "email") {
                val = val.toLowerCase();
              }
              formik?.setFieldValue(name, val);
            }}
            onBlur={formik?.handleBlur}
            value={formik?.values[name]}
            disabled={disabled}
            {...props}
          />

          <Form.Label className="floating-label">
            {placeholder}
            {strToLowerCase(placeholder) != "company" ? "*" : " "}
          </Form.Label>
        </Form.Group>
        {formik.touched[name] && formik.errors[name] ? (
          <span className="error-msg d-block">{formik.errors[name]}</span>
        ) : null}
      </div>
    </div>
  );
}

export default FormInput;
